import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tree-square-dot"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M9.5 3H14.5V8H9.5V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 16H21V21H16V16Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 16H8V21H3V16Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 8V12.3333M12 12.3333H5.5V16M12 12.3333H18.5V16M9.5 3H14.5V8H9.5V3ZM16 16H21V21H16V16ZM3 16H8V21H3V16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TreeSquareDot = Vue.extend<IconProps>({
  name: 'TreeSquareDotIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tree-square-dot',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TreeSquareDot;
